// @ts-strict-ignore
import React from 'react'
import { Fade } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Suspense from 'components/Suspense'
import SuspensePlaceholder from 'components/SuspensePlaceholder'
import Box from 'components/Box'
import { classList, StandardWidth } from 'services/styles'
import { makeStyles } from 'tss-react/mui'
import PageLoadingIndicator from '../PageLoadingIndicator'

export interface IPageContentProps extends React.HTMLProps<HTMLDivElement> {
  maxWidth?: StandardWidth
}

function getStyle(style: React.CSSProperties, width: number): React.CSSProperties {
  if (style) {
    return {
      ...style,
      maxWidth: width || '100vw',
    }
  }

  return {
    maxWidth: width || '100vw',
  }
}

const useStyles = makeStyles()(theme => ({
  container: {
    flexGrow: '1',
    position: 'relative',
    zIndex: '4',
    marginBottom: theme.spacing(8),
    transition: 'max-width 0.4s ease',
    width: '100%',
    minWidth: 0,
    minHeight: 'calc(100vh - 100px)', /* this roughly makes all pages come out right */
  },
  box: {
    minHeight: 'calc(100vh - 100px)', /* this roughly makes all pages come out right */
  },
}))

const PageContent: React.FunctionComponent<IPageContentProps> = (props) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const { children, className, maxWidth, style, ...restProps } = props

  return (
    <Fade appear in>
      <div className={classList(classes.container, className)} style={getStyle(style, theme.breakpoints.values[maxWidth])} {...restProps}>
        <Suspense
          fallback={<PageLoadingIndicator />}
          ErrorFallbackComponent={errorProps => (
            <SuspensePlaceholder {...errorProps} raised={false} flat />
          )}
        >
          <Box className={classes.box}>
            {children}
          </Box>
        </Suspense>
      </div>
    </Fade>
  )
}

export default PageContent
